import React   from "react";
import ReactLoading from 'react-loading';

import { useSelector,useDispatch }              from "react-redux";
import { 
    setCadenaBusquedaAction,
    setArticulosAction
}                                               from "../../actions/searchActions";


const InSearch = ({isMobile}) => {
    const dispatch = useDispatch();

    //const [itemName, setNameItem] = React.useState("");
    let busquedaObj = useSelector((state) => state.search);


    const nuevaBusqueda = ( cadenaBusqueda ) => {
        //setNameItem(cadenaBusqueda);
        dispatch(setCadenaBusquedaAction(cadenaBusqueda,busquedaObj.articulos));
    }

    busquedaObj.categorias != null && busquedaObj.articulos === null && dispatch(setArticulosAction(busquedaObj.categorias))

    return (
        <div className={isMobile ? "in-search-h mobile" : "in-search-h"}>
            {
                busquedaObj.articulos === null 
                ?   <ReactLoading type="cylon" color="#000" width={'100%'} />
                :   <label className="in-label">
                        <div className="in-label-icon">
                            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20.001" viewBox="0 0 20 20.001"><path id="bx-search" d="M10.553,19.106a8.5,8.5,0,0,0,5.235-1.8l4.7,4.7L22,20.489l-4.7-4.7a8.543,8.543,0,1,0-6.747,3.316Zm0-14.968a6.415,6.415,0,1,1-6.415,6.415A6.421,6.421,0,0,1,10.553,4.138Z" transform="translate(-2 -2)" fill="#000000"></path></svg>
                        </div>
                        <input 
                            type="search" 
                            name="btnSearch" 
                            value={busquedaObj.cadenaBusqueda} 
                            placeholder="Búsqueda" 
                            className="in-general in-search" 
                            onChange={(e) => nuevaBusqueda( e.target.value )}
                        />
                    </label>
            }
        </div>
    );
};

export default InSearch;
